module.exports = __webpack_public_path__ + "static/media/junctionx_globe_white.f9bcbe82.png";